import {
  LEARNING_PATH_OPEN_INFORMATION_FORM,
  LEARNING_PATH_SUBMITTED_INFORMATION_FORM,
  LEARNING_PATH_TOGGLE_INFORMATION_FORM,
} from '../actions/types';

export const INITIAL_STATE = {
  shown: false,
  submitted: false,
};

export function informationForm(state = INITIAL_STATE, action) {
  const { type } = action;

  switch (type) {
    case LEARNING_PATH_OPEN_INFORMATION_FORM:
      return {
        ...state,
        shown: true,
      };

    case LEARNING_PATH_TOGGLE_INFORMATION_FORM:
      return {
        ...state,
        shown: !state.shown,
      };

    case LEARNING_PATH_SUBMITTED_INFORMATION_FORM:
      return {
        ...state,
        submitted: true,
      };

    default:
      return state;
  }
}

export default informationForm;
